import { ArrowLeft } from '@phosphor-icons/react'
import { isRouteErrorResponse, Link, useRouteError } from 'react-router'

import { Button } from '@/components/ui/button'
import { homePathFor, useSession } from '@/lib/session'

function Frame({ code, title, body }: { code: string; title: string; body: string }) {
  const { data: user } = useSession()
  return (
    <main className="flex min-h-dvh flex-col items-center justify-center px-6 text-center">
      <p className="font-mono text-xs tracking-widest text-ink-4">{code}</p>
      <h1 className="mt-3 font-display text-5xl text-ink">{title}</h1>
      <p className="mt-3 max-w-md text-ink-3">{body}</p>
      <Button asChild className="mt-8">
        <Link to={homePathFor(user)}>
          <ArrowLeft />
          Back to safety
        </Link>
      </Button>
    </main>
  )
}

export function NotFound() {
  return (
    <Frame
      code="404"
      title="Nothing here."
      body="The page you were looking for has moved or never existed."
    />
  )
}

export function RouteError() {
  const error = useRouteError()
  if (isRouteErrorResponse(error) && error.status === 404) return <NotFound />
  // A new deployment replaced the chunk this tab was trying to load.
  const stale = error instanceof Error && /dynamically imported module|Failed to fetch/i.test(error.message)
  return (
    <Frame
      code={stale ? 'UPDATE' : 'ERROR'}
      title={stale ? 'A new version is ready.' : 'Something broke.'}
      body={
        stale
          ? 'Refresh the page to load the latest version of the app.'
          : 'An unexpected error stopped this page. Refresh to try again — if it keeps happening, let the placement team know.'
      }
    />
  )
}
